import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import { RequireAuth } from "./components/RequireAuth";
import StudentLayout from "./components/StudentLayout";
import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import TopicSelect from "./pages/TopicSelect";
import Session from "./pages/Session";
import SessionResult from "./pages/SessionResult";
import MathMap from "./pages/Map";
import Profile from "./pages/Profile";
import SessionReview from "./pages/SessionReview";
import WrongAttempts from "./pages/WrongAttempts";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminQuestions from "./pages/admin/AdminQuestions";
import AdminQuestionEditor from "./pages/admin/AdminQuestionEditor";
import AdminTopics from "./pages/admin/AdminTopics";
import AdminCurriculum from "./pages/admin/AdminCurriculum";
import AdminCatalog from "./pages/admin/AdminCatalog";
import AdminTeacherApplications from "./pages/admin/AdminTeacherApplications";
import AdminImages from "./pages/admin/AdminImages";
import AdminTags from "./pages/admin/AdminTags";
import AdminStudents from "./pages/admin/AdminStudents";
import AdminVideoOps from "./pages/admin/AdminVideoOps";
import TeacherApplication from "./pages/TeacherApplication";
import TeacherPanel from "./pages/TeacherPanel";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import TeacherStudentDetail from "./pages/TeacherStudentDetail";
import ProgressReport from "./pages/ProgressReport";

function AppRouter() {
  return (
    <Routes>
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/giris" element={<LoginPage />} />
      <Route path="/kayit" element={<RegisterPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      <Route path="/oturum/:id" element={<RequireAuth><Session /></RequireAuth>} />
      <Route path="/sonuc/:id" element={<RequireAuth><SessionResult /></RequireAuth>} />
      <Route path="/inceleme/:id" element={<RequireAuth><SessionReview /></RequireAuth>} />
      <Route path="/ogretmen" element={<RequireAuth><TeacherPanel /></RequireAuth>} />
      <Route path="/ogretmen/sinif/:classId/ogrenci/:studentId" element={<RequireAuth><TeacherStudentDetail /></RequireAuth>} />

      <Route element={<RequireAuth><StudentLayout /></RequireAuth>}>
        <Route index element={<Dashboard />} />
        <Route path="/konular" element={<TopicSelect />} />
        <Route path="/harita" element={<MathMap />} />
        <Route path="/profil" element={<Profile />} />
        <Route path="/yanlislar" element={<WrongAttempts />} />
        <Route path="/ogretmen-basvuru" element={<TeacherApplication />} />
        <Route path="/gelisim" element={<ProgressReport />} />
      </Route>

      <Route path="/admin" element={<RequireAuth adminOnly><AdminLayout /></RequireAuth>}>
        <Route index element={<AdminDashboard />} />
        <Route path="sorular" element={<AdminQuestions />} />
        <Route path="sorular/yeni" element={<AdminQuestionEditor />} />
        <Route path="sorular/:id" element={<AdminQuestionEditor />} />
        <Route path="konular" element={<AdminTopics />} />
        <Route path="mufredat" element={<AdminCurriculum />} />
        <Route path="katalog" element={<AdminCatalog />} />
        <Route path="ogretmen-basvurulari" element={<AdminTeacherApplications />} />
        <Route path="gorseller" element={<AdminImages />} />
        <Route path="etiketler" element={<AdminTags />} />
        <Route path="ogrenciler" element={<AdminStudents />} />
        <Route path="video-firsatlari" element={<AdminVideoOps />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster richColors closeButton position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}
